const initialState = {
    data: null,
};
export const EditDocumentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'EDITDOCUMENT_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'EDITDOCUMENT_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default EditDocumentReducer;